import {
	ArrowLeftOutlined,
	DeleteOutlined,
	EditOutlined,
	EnvironmentOutlined,
} from "@ant-design/icons";
import { Button, Card, Popconfirm, Skeleton, Space } from "antd";
import { useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { TerritoryFormModal } from "../components/TerritoryFormModal";
import { TerritoryInfoCard } from "../components/TerritoryInfoCard";
import { TerritoryPlantingsTable } from "../components/TerritoryPlantingsTable";
import { TerritoryPolygonMap } from "../components/TerritoryPolygonMap";
import { TerritoryTasksTable } from "../components/TerritoryTasksTable";
import { useDeleteTerritory, useTerritory } from "../hooks/useTerritories";

export function TerritoryDetailPage() {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();
	const [isEditOpen, setIsEditOpen] = useState(false);

	const { data: territory, isLoading } = useTerritory(id);
	const { mutate: deleteTerritory, isPending: isDeleting } = useDeleteTerritory();

	if (!id) {
		return <Navigate to="/organizations" replace />;
	}

	const handleDelete = () => {
		deleteTerritory(id, {
			onSuccess: () => {
				navigate(-1);
			},
		});
	};

	return (
		<div className="space-y-4">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-3">
					<Button
						type="text"
						icon={<ArrowLeftOutlined />}
						onClick={() => navigate(-1)}
						size="small"
						className="text-ink-soft"
					/>
					{isLoading ? (
						<Skeleton.Input active size="small" style={{ width: 180 }} />
					) : (
						<h4 className="text-lg font-semibold m-0">{territory?.name ?? "Hudud"}</h4>
					)}
				</div>

				{territory && (
					<Space>
						<Button icon={<EditOutlined />} size="small" onClick={() => setIsEditOpen(true)}>
							Tahrirlash
						</Button>
						<Popconfirm
							title="Hududni o'chirish"
							description="Haqiqatan ham ushbu hududni o'chirmoqchimisiz?"
							onConfirm={handleDelete}
							okText="O'chirish"
							cancelText="Bekor qilish"
							okButtonProps={{ danger: true, loading: isDeleting }}
						>
							<Button icon={<DeleteOutlined />} size="small" danger>
								O'chirish
							</Button>
						</Popconfirm>
					</Space>
				)}
			</div>

			<Card size="small">
				{isLoading ? (
					<Skeleton active paragraph={{ rows: 3 }} />
				) : territory ? (
					<TerritoryInfoCard territory={territory} />
				) : null}
			</Card>

			{territory && (
				<>
					<Card
						size="small"
						title={
							<span className="font-semibold flex items-center gap-1">
								<EnvironmentOutlined /> Hudud xaritasi
							</span>
						}
					>
						<TerritoryPolygonMap territory={territory} />
					</Card>
					<Card size="small" title={<span className="font-semibold">Vazifalar</span>}>
						<TerritoryTasksTable
							organizationId={territory.organizationId}
							brigadeId={territory.assignedBrigades[0]?.id}
						/>
					</Card>
					<Card size="small" title={<span className="font-semibold">Ekinlar</span>}>
						<TerritoryPlantingsTable organizationId={territory.organizationId} territoryId={id} />
					</Card>

					<TerritoryFormModal
						open={isEditOpen}
						onClose={() => setIsEditOpen(false)}
						organizationId={territory.organizationId}
						territory={territory}
					/>
				</>
			)}
		</div>
	);
}
